module.exports = __webpack_public_path__ + "img/aggregate_ui.89cba8cf.svg";